import React, { useEffect } from 'react';
import { connect } from 'react-redux';
import InsumoRecord from '@components/InsumoRecord/InsumoRecord';
import formatMessage from './i18n/formatMessage';
import Insumo from '@resources/InsumosEnum';

/**
 * Componente para tela de Acaricidas
 *
 * @author Gabriela Farias <gabriela.farias@kepha.com.br>
 * @param {*} props
 * @returns {JSX.Element}
 */
function Acaricidas(props) {
  useEffect(() => {
    const title = 'acaricida.acaricida';
    if (props.itensState.name !== title) {
      props.dispatch({ type: 'UPDATE_TOOLBAR', toolbar: formatMessage(title), name: title });
    }
  }, []);

  return (
    <InsumoRecord
      chipData={props.chipData}
      infoUsuario={props.infoUsuario}
      insumoEnum={Insumo.ACARICIDA}
      insumoURL='acaricidas'
      viewKey='acaricidas'
      deleteMessageSucess={formatMessage(
        'acaricida.acaricidaRemovidoComSucesso'
      )}
      mensagemFalhaDeletar={formatMessage('acaricida.falhaAoExcluirAcaricida')}
      mensagemDelete={formatMessage('acaricida.desejaExcluir')}
    />
  );
}

const mapStateToProps = state => ({
  itensState: state.toolbar,
  infoUsuario: state.adicionarInfoUsuario.info,
  chipData: state.chips.chipData.filter(date => {
    return date.id === 'acaricidas';
  })[0].content
});

export default connect(mapStateToProps)(Acaricidas);
